(function ($) {
    $(".change_text").click(function () {
        $(this).toggleClass('open');

        if ($(".change_text").hasClass('open')) {
            $('.collapse').collapse('hide');
        } else {

        }
        if ($(".change_text").not(this).hasClass('open')) {
            $(".change_text").not(this).removeClass('open');
        }
    });
    $('.close_bio').click(function () {
        $(".change_text").removeClass('open');
    });

    if ($('.our_team_section_team').length > 0) {
        var windowWidth2 = $(window).width();

        var total_peopele = $('.team-wrap .people_wrap').length;
        if (windowWidth2 > 992) {

            $(".clear").remove();
            for (i = 1; i <= total_peopele; i++) {
                if (!(i % 4) || total_peopele == i) {
                    var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                    $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                }
            }
        }
        if (windowWidth2 < 992 && windowWidth2 > 500) {

            $(".clear").remove();
            for (i = 1; i <= total_peopele; i++) {
                if (!(i % 2) || total_peopele == i) {
                    var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                    $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                }
            }
        }
        if (windowWidth2 < 500) {

            $(".clear").remove();
            for (i = 1; i <= total_peopele; i++) {
                if (!(i % 1) || total_peopele == i) {
                    var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                    $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                }
            }
        }

        $(window).resize(function () {
            var windowWidth = $(window).width();
            if (windowWidth2 != windowWidth) {
                if (windowWidth > 992) {
                    windowWidth2 = $(window).width();
                    console.log("window size > 992");
                    $(".clear").remove();
                    for (i = 1; i <= total_peopele; i++) {
                        if (!(i % 4) || total_peopele == i) {
                            var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                            $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                        }
                    }
                }
                if (windowWidth < 992 && windowWidth > 500) {
                    windowWidth2 = $(window).width();
                    console.log("window size < 992");
                    $(".clear").remove();
                    for (i = 1; i <= total_peopele; i++) {
                        if (!(i % 2) || total_peopele == i) {
                            var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                            $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                        }
                    }
                }
                if (windowWidth < 500) {
                    windowWidth2 = $(window).width();
                    console.log("window size 500");
                    $(".clear").remove();
                    for (i = 1; i <= total_peopele; i++) {
                        if (!(i % 1) || total_peopele == i) {
                            var appent = $('.team-wrap .people_wrap:eq(' + (i - 1) + ')');
                            $(appent).after('<div class="clear collapse"><div class="well">...</div> </div>');
                        }
                    }
                }
            }
        });



        $('.people').on('click', function () {
            if ($(this).parent().hasClass('active')) {
                $('.collapse').collapse('hide');
                $('.people_wrap ').removeClass('active');
            } else {
                var content = $(this).find('.content').clone();
                var container = $(this).closest('.people_wrap').nextAll('.clear')[0];
                content.append($("<div class='close'><span>X</span> Close</div>"));

                $('.collapse').collapse('hide');
                $('.people_wrap ').removeClass('active');
                $(this).parent().addClass('active');
                setTimeout(
                    function () {
                        $(container).html(content);
                        $('.close').click(function () {
                            $('.collapse').collapse('hide');
                            $('.people_wrap ').removeClass('active');
                        });
                    }, 200);
                setTimeout(
                    function () {
                        $(container).collapse('show');
                    }, 400);
                setTimeout(
                    function () {
                        $('html,body').animate({
                            scrollTop: $(container)[0].offsetTop - 170
                        }, 500);
                    }, 500);

            }
        });
    }

})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./src/js/our-team.js
// module id = 14
// module chunks = 0